import Newsletter from './Newsletter.container';

export default Newsletter;
